import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {
    CompleteFundTransfer,
    FundTransfer,
    VirtualNin
} from "../../redux/selfService/selfServiceSlice";
import React, {useState} from "react";
import LoadingSpinner from "../../components/LoadingSpinner";
import PageName from "../../components/PageName";
import SuccessModal from "../../components/SuccessModal";
import Card from "../../components/Base/Card";
import ErrorViewer from "../../components/ErrorViewer";
import Required from "../../components/Required";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {FundType} from "../../constants";
import TimeOutActivityLayout from "../auth/inactivity-timeout-v2";

const FundsTransferPage = () => {
    const dispatch = useAppDispatch();
    const [formStep, setFormStep] = useState(0);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const { isLoading } = useAppSelector((state) => state?.selfService);
    const { user } = useAppSelector((state) => state?.auth);


    const validationSchema = Yup.object().shape({
        // designation: Yup.string().required("Please enter designation"),
        // officialEmail: Yup.string().required("Please enter your official email"),
        newFundType: Yup
            .string()
            .when("formStep", {
                is: (val:string)=>val==="0",
                then: ()=>Yup.string().required('Please select')}),
        token: Yup
            .string()
            .when("formStep", {
                is: (val:string)=>val==="1",
                then: ()=>Yup.string()
                    .min(6, 'Must be exactly 6 digits')
                    .max(6, 'Must be exactly 6 digits')
                    .required('Please Enter token'),
            }),
    });

    const defaultValues = {
        formStep: 0,
        newFundType: "",
        token: "",
        // designation: "",
        // officialEmail: "",
        // type: 0,
    }

    const { handleSubmit, register, setValue, reset, formState: { errors },} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues
    });

    const onSubmit = (values: any) => {
        if(formStep==0) {
            dispatch(FundTransfer({
                newFundType: parseInt(values.newFundType, 10),
            })).then(res => {
                if (res?.type === 'selfService/FundTransfer/fulfilled' && !res.payload.statusMessage.startsWith("You have a pending request")) {
                    reset(defaultValues)
                    setFormStep(1)
                }
            })
        }else {
            dispatch(CompleteFundTransfer({token:values.token})).then(res=>{
                if (res?.type === 'selfService/CompleteFundTransfer/fulfilled') {
                    reset(defaultValues)
                    setFormStep(0)
                }
            })
        }
    }
    return (
        <TimeOutActivityLayout>
        <div className="statement-page">
            <PageName pageName={"Funds Transfer"}/>
            <div>
                <SuccessModal
                    showModal={showSuccessModal}
                    onClose={()=>setShowSuccessModal(false)}
                    note={successMessage}
                />
                <div className="mx-4">

                    <div className="h1 text-grayscaleBody">
                        Funds Transfer
                    </div>
                    <div className="w-full">
                        <Card className="mb-8 bg-grayscaleBG">
                            {
                                formStep === 0 && (
                                    <div className="section-card">
                                        <div className="pt-12 whitespace-pre mr-6">
                                            Funds Transfer
                                        </div>
                                        <div className="w-full">
                                            <div className="mx-auto max-w-[400px]">
                                                {/*
                                        <div className="form__group">
                                            <label htmlFor="designation" className="form__label">
                                                Designation <Required />
                                            </label>
                                            <input placeholder="Designation" type="text" id="designation"
                                                   className="form__input" {...register("designation")} />
                                            {errors.designation && (
                                                <ErrorViewer message={errors.designation.message as string}/>
                                            )}
                                        </div>
                                        <div className="form__group">
                                            <label htmlFor="officialEmail" className="form__label">
                                                Official Email <Required />
                                            </label>
                                            <input placeholder="Official email" type="email" id="officialEmail"
                                                   className="form__input" {...register("officialEmail")} />
                                            {errors.officialEmail && (
                                                <ErrorViewer message={errors.officialEmail.message as string}/>
                                            )}
                                        </div>
                                        */}
                                                <div className="form__group">
                                                    <label htmlFor="newFundType" className="form__label">
                                                        New Fund Type <Required />
                                                    </label>
                                                        <select id="newFundType" className="form__select" {...register('newFundType')}>
                                                            <option value="" disabled>Select New Fund Type</option>
                                                            {
                                                                FundType.map((fundType, index)=>(
                                                                    <option value={index} key={index}>{fundType}</option>
                                                                ))
                                                            }
                                                        </select>
                                                    {errors.newFundType && (
                                                        <ErrorViewer message={errors.newFundType.message as string}/>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            {
                                formStep === 1 && (
                                    <div className="section-card">
                                        <div className="pt-12 whitespace-pre mr-6">
                                            Enter Token
                                        </div>
                                        <div className="w-full">
                                            <div className="mx-auto max-w-[400px]">
                                                <div className="form__group">
                                                    <label htmlFor="token" className="form__label">
                                                        Token <Required />
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="token"
                                                        className="form__input scattered"
                                                        maxLength={6}
                                                        {...register("token")}
                                                    />
                                                    {errors.token && (
                                                        <ErrorViewer message={errors.token.message as string}/>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </Card>
                        <div className="flex justify-end text-primary mb-40">
                            <button
                                className="btn btn-primary font-semibold mr-4"
                                onClick={handleSubmit(onSubmit)}
                                disabled={isLoading}
                            >
                                {
                                    isLoading ? <LoadingSpinner /> : "Continue"
                                }
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        </TimeOutActivityLayout>
    )
}
export default FundsTransferPage;